<template>
  <div>
    <div class="my-6 heading-5">
      {{ group.title }}
    </div>
    <VExpansionPanels>
      <VExpansionPanel
        v-for="item in group.items"
        :key="item.id"
      >
        <VExpansionPanel-header>
          <span class="heading-6"> {{ item.question }} </span>
        </VExpansionPanel-header>
        <VExpansionPanel-content>
          <VueMarkdown class="body-1">
            {{ item.answer }}
          </VueMarkdown>
        </VExpansionPanel-content>
      </VExpansionPanel>
    </VExpansionPanels>
  </div>
</template>

<script lang="ts">
export default {
  name: 'FaqGroup',
};
</script>

<script setup lang="ts">
import VueMarkdown from 'vue-markdown';

defineProps({
  group: {
    type: Object,
    default: () => {},
  },
});
</script>
